module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"image":"I","lock":"L","keyPoints":"K","outline":"O","variant":"V"}}')
  delete Component.options._Ctor
}
